import { Portal, Box, useDisclosure } from "@chakra-ui/react";
// import Footer from 'components/footer/FooterAdmin.js';
import Navbar from "components/navbar/NavbarAdmin.js";
import Sidebar from "components/sidebar/Sidebar.js";
import { SidebarContext } from "contexts/SidebarContext";
import React, { useState, useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import routes from "routes.js";
import DocumentUploadModal from "components/modals/DocumentUploadModal";
import { useAuth } from "hooks/useAuth";
import { authService } from "services/auth.service";
import ApprovalStatusModal from "components/modals/ApprovalStatusModal";

export default function UserLayout(props) {
  const { ...rest } = props;
  const [fixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const [showDocModal, setShowDocModal] = useState(false);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    // Check document verification status when component mounts
    const checkDocumentStatus = async () => {
      const currentUser = authService.getUser();
      if (currentUser?.documentVerificationStatus === "PENDING") {
        setShowDocModal(true);
      } else if (
        currentUser?.documentVerificationStatus === "WAITING_FOR_APPROVAL" ||
        currentUser?.documentVerificationStatus === "REJECTED"
      ) {
        setShowApprovalModal(true);
      }
    };

    checkDocumentStatus();
  }, []);

  const handleDocumentUpload = async (documents) => {
    try {
      await authService.uploadDocuments(documents);
      setShowDocModal(false);
      setShowApprovalModal(true);
    } catch (error) {
      console.error("Error uploading documents:", error);
    }
  };

  const getRoute = () => {
    return window.location.pathname !== "/user/full-screen-maps";
  };

  const getActiveRoute = (routes) => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].items);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (routes[i].category) {
        let categoryActiveRoute = getActiveRoute(routes[i].items);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/user") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      }
      if (prop.collapse) {
        return getRoutes(prop.items);
      }
      if (prop.category) {
        return getRoutes(prop.items);
      } else {
        return null;
      }
    });
  };

  const { onOpen } = useDisclosure();
  document.documentElement.dir = "ltr";

  return (
    <Box>
      <SidebarContext.Provider
        value={{
          toggleSidebar,
          setToggleSidebar,
        }}>
        <Sidebar routes={routes} display="none" {...rest} />
        <Box
          bg="white"
          float="right"
          minHeight="100vh"
          height="100%"
          overflow="auto"
          position="relative"
          maxHeight="100%"
          w={{ base: "100%", xl: "calc( 100% - 251px )" }}
          maxWidth={{ base: "100%", xl: "calc( 100% - 251px )" }}
          transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
          transitionDuration=".2s, .2s, .35s"
          transitionProperty="top, bottom, width"
          transitionTimingFunction="linear, linear, ease">
          <Portal>
            <Box
              w={{
                base: "calc(100vw - 0%)",
                md: "calc(100vw - 0%)",
                lg: "calc(100vw - 0%)",
                xl: "calc(100vw - 251px)",
                "2xl": "calc(100vw - 251px)",
              }}
              position="fixed"
              top="0"
              right="0"
              height="88px"
              py=".75rem"
              borderBottom="1px solid #CBD5E1"
              bg="#fff"
              zIndex="1000">
              <Navbar
                onOpen={onOpen}
                logoText={"User Dashboard"}
                brandText={getActiveRoute(routes)}
                secondary={false}
                fixed={fixed}
                {...rest}
              />
            </Box>
          </Portal>

          {getRoute() ? (
            <Box
              mx="2rem"
              minH="calc(100vh - 160px)"
              height="100%"
              mt="110px"
              pb="100px">
              <Switch>
                {getRoutes(routes)}
                <Redirect from="/user" to="/user/profile" />
              </Switch>
            </Box>
          ) : null}
          <Box height="50px">{/* <Footer /> */}</Box>
        </Box>
      </SidebarContext.Provider>

      <DocumentUploadModal
        isOpen={showDocModal}
        onClose={() => setShowDocModal(false)}
        onUpload={handleDocumentUpload}
      />

      <ApprovalStatusModal
        isOpen={showApprovalModal}
        onClose={() => setShowApprovalModal(false)}
      />
    </Box>
  );
}
